<template>
  <close-button @click="close" colour="grey"/>
</template>

<script>
import { mapActions } from 'vuex'
import CloseButton from '@/components/Buttons/CloseButton'

export default {
  name: 'CloseUserMenuButton',
  components: { CloseButton },
  methods: {
    ...mapActions(
      {
        close: 'localModal/close',
      },
    ),
  },
}
</script>
